__turbopack_context__.v({
  "confirmationLink": "ConfirmationLinks-module__9qng5a__confirmationLink",
  "confirmationLinksContainer": "ConfirmationLinks-module__9qng5a__confirmationLinksContainer",
  "linkArrowWrapper": "ConfirmationLinks-module__9qng5a__linkArrowWrapper",
  "linkImageOverlay": "ConfirmationLinks-module__9qng5a__linkImageOverlay",
  "linkImageWrapper": "ConfirmationLinks-module__9qng5a__linkImageWrapper",
  "linkLabel": "ConfirmationLinks-module__9qng5a__linkLabel",
  "linkLabelArrowContainer": "ConfirmationLinks-module__9qng5a__linkLabelArrowContainer",
});
